<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      :confirmText="confirmText"
      :expandText="expandText"
      type="info"
      size="normal">
    <template #header>
      <span>{{title}}</span>
    </template>
    <template #content>
      <div class="content" :style="contentStyle">
        <gj-text-alert
            v-if="type !== 'text'"
            :type="type">
          <span v-html="content"></span>
        </gj-text-alert>
        <template v-else>
          <span v-html="content"></span>
        </template>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../minxins";

  export default {
    name: "gj-info-modal",
    mixins: [modalMixIn],
    props: {
      title: {
        type: String,
        default: '提示'
      },
      content: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: 'warning',
        validator: function (value) {
          return ['success', 'warning', 'text'].indexOf(value) !== -1
        }
      },
      contentStyle: {
        type: Object,
        default: () => {}
      },
      confirmText: {
        type: String,
        default: '确定'
      },
      expandText: {
        type: String,
        default: ''
      },
    }
  }
</script>

<style lang="scss" scoped>
  .content {
    padding: 0;
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0 !important;
  }
  /deep/ .el-row--flex.is-align-middle{
    align-items: stretch;
  }
  .danger-text {
    color: red;
    font-weight: bold;
  }
</style>
